import { render, staticRenderFns } from "./AddIujptlSearch.vue?vue&type=template&id=7411c6b2&scoped=true&"
import script from "./AddIujptlSearch.vue?vue&type=script&lang=js&"
export * from "./AddIujptlSearch.vue?vue&type=script&lang=js&"
import style0 from "./AddIujptlSearch.vue?vue&type=style&index=0&id=7411c6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7411c6b2",
  null
  
)

export default component.exports